import { MainInner } from "@/styles/global";
import { Wysiwyg } from "@/styles/typography";
import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";

export interface Props {
  content: string;
  animation: string;
}

const StandardEditor: React.FC<Props> = ({ content, animation }) => {
  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <MainInner>
        <Wysiwyg dangerouslySetInnerHTML={{ __html: content }} />
      </MainInner>
    </AnimationOnScroll>
  );
};

export default StandardEditor;
